import { configureStore } from '@reduxjs/toolkit'
import { artsAPI } from '../services/arts.service'
import { authAPI } from '../services/auth.service'
import { articlesAPI } from '../services/articles.service'
import { articlesReducer } from './slices/articles.slice'
import { authReducer } from './slices/auth.slice'
import { generalReducer } from './slices/general.slice'
import { userReducer } from './slices/user.slice'
import { creatorsAPI } from '../services/creators.service'
import { adminAPI } from '../services/admin.service'
import { settingsAPI } from '../services/settings.service'
import { importAPI } from '../services/import.service'
import { inspirationAPI } from '../services/inspiration.service'
import { promptsAPI } from '../services/prompts.service'
import { usersAPI } from '../services/users.service'

export const store = configureStore({
  reducer: {
    authReducer,
    userReducer,
    articlesReducer,
    generalReducer,

    [authAPI.reducerPath]: authAPI.reducer,
    [articlesAPI.reducerPath]: articlesAPI.reducer,
    [artsAPI.reducerPath]: artsAPI.reducer,
    [creatorsAPI.reducerPath]: creatorsAPI.reducer,
    [adminAPI.reducerPath]: adminAPI.reducer,
    [settingsAPI.reducerPath]: settingsAPI.reducer,
    [importAPI.reducerPath]: importAPI.reducer,
    [inspirationAPI.reducerPath]: inspirationAPI.reducer,
    [promptsAPI.reducerPath]: promptsAPI.reducer,
    [usersAPI.reducerPath]: usersAPI.reducer,

  } as any,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(authAPI.middleware)
    .concat(articlesAPI.middleware)
    .concat(artsAPI.middleware)
    .concat(creatorsAPI.middleware)
    .concat(adminAPI.middleware)
    .concat(settingsAPI.middleware)
    .concat(importAPI.middleware)
    .concat(inspirationAPI.middleware)
    .concat(promptsAPI.middleware)
    .concat(usersAPI.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
